export var ChatType;
(function (ChatType) {
    ChatType["DialogChat"] = "dialogChat";
    ChatType["GroupChat"] = "groupChat";
})(ChatType || (ChatType = {}));
